<template>
  <div class="cal-selected-day-panel">
    <div v-if="selectedDay" class="cal-selected-day-label">
      <span class="cal-selected-day-dow">{{ dayName }}</span>
      <span class="cal-selected-day-num">{{ dayNum }}</span>
      <span class="cal-selected-day-month">{{ monthName }}</span>
    </div>
    <div v-else class="cal-selected-day-dow">Sélectionnez un jour</div>
    <span v-if="selectedDay" class="cal-selected-day-count">
      {{ eventCount }} événement{{ eventCount !== 1 ? 's' : '' }}
    </span>
  </div>
</template>

<script setup lang="ts">
import type { Dayjs } from 'dayjs';

const props = defineProps<{
  selectedDay: Dayjs | null;
  eventCount: number;
}>();

const dayName = computed(() =>
  props.selectedDay ? props.selectedDay.format('ddd').toUpperCase() : '',
);
const dayNum = computed(() =>
  props.selectedDay ? props.selectedDay.format('D') : '',
);
const monthName = computed(() =>
  props.selectedDay ? props.selectedDay.format('MMM').toUpperCase() : '',
);
</script>
